<template>
    <Transition name="fade">
    <div v-if="showAddPropertiesModal && this.loadedGeometrySelected >= 0 && loadedGeometries && loadedGeometries.length > 0"
         class="col-6 col-lg-3 right property-dialog px-2">
        <div>
            <h4 class="span-title pl-1 text-light" >{{ $t('orders.add_property_value') }}</h4>
        </div>

        <div v-if="newProperties && Object.keys(newProperties)" class="col-12 nopads">
            <div v-for="(geometryProperty, index) in Object.keys(newProperties)" :key="'geometry-property'+index" class="col-12 nopads">
                <div v-if="!excludedFields.includes(geometryProperty)" class="nopads">
                    <span class="span-title text-light">{{ geometryProperty }}</span>
                    <div class="input-group input-group-sm">
                        <input
                            type="text"
                            class="form-control"
                            :id="'name'"
                            v-model="newProperties[geometryProperty]"
                        />
                        <button
                            class="btn btn-danger"
                            type="button"
                            @click.stop="$emit('removeProperty', geometryProperty)"
                        >
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
      <!-- Placeholder for a new one -->
          <order-geometry-property-selector
              :large-mode="true"
              ref="orderGeometryPropertySelector"
              @addProperty="(newProperty) => addProperty(newProperty)"/>
        <div class="button-container pr-1 pt-2">
            <button
                class="btn btn-secondary btn-sm form-button"
                @click.stop="resetDrawing"
            >
                {{ $t('common.cancel') }}
            </button>
            <button
                class="btn btn-success btn-sm form-button"
                @click.stop="addToGeometry"
            >
              {{ this.showAddPropertiesModal ? this.$t('common.save')
                : addPolylineEnabled ? this.$t('orders.add_line_to_geometry')
                    : addPointEnabled ? this.$t('orders.add_point_to_geometry')
                        : this.$t('orders.add_line_to_geometry') }}
            </button>
        </div>
    </div>
    </Transition>
</template>

<script>

import OrderGeometryPropertySelector from "./OrderGeometryPropertySelector.vue";

export default {
    name: "OrderGeometryAddPropertyModal",
  components: {OrderGeometryPropertySelector},
    props: {
        showAddPropertiesModal: {
            type: Boolean,
            default: false
        },
        loadedGeometrySelected: {
            type: Number,
            default: null
        },
        loadedGeometries: {
            type: Array,
            default() {
                return []
            }
        },
        newProperties: {
            type: Object,
            default: null
        },
        selectedLayer: {
            type: Object,
            default: null
        },
        excludedFields: {
            type: Array,
            default() {
                return []
            }
        },
        addPolylineEnabled: {
            type: Boolean,
            default: false
        },
        addPointEnabled: {
            type: Boolean,
            default: false
        },

    },
    methods: {
        reset() {
            this.$refs.orderGeometryPropertySelector.reset();
        },
        addToGeometry() {
            this.$emit('onAddToGeometry')
        },
        addProperty(property) {
          this.$emit('addProperty', property)
        },
        resetDrawing() {
            this.$emit('onResetDrawing')
        }
    }
}
</script>
<style>
.property-dialog {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    overflow: auto;
    border-top-left-radius: .5em;
    border-bottom-left-radius: .5em;
    z-index: 10;
    background-color: rgba(43, 43, 43, 0.8);
    border: 1px solid #404041;
    backdrop-filter: blur(3px);
}
</style>
